"use strict";

($dt => {

	/**
	 * This screen is for prompting the user with logging in option if they are anonymouse.
	 * 
	 * @param {Block} block 
	 * @param {InnerScreen} inner_screen 
	 * @param {*} controller 
	 */
	$dt.TopicGrid.ScreenFunctions.o0_i1 = (block, inner_screen, controller) => {
		// Screen is shown when user is anonymous, init text link to move forward anonymously
		const [ proceed_without_login_elem, link_button_elems ] = [ 
			inner_screen.inner_elem.querySelector('.proceed-without-login'),
			inner_screen.inner_elem.querySelectorAll('button[data-href]')
		];

		// Proceed event
		proceed_without_login_elem.addEventListener('click', () => {
			block.current_screen.inner = 2;
			controller.SetScreenUI(block);
		});

		// Login/signup links
		link_button_elems.forEach(elem => {
			elem.addEventListener('click', () => {
				window.location.href = elem.getAttribute('data-href');
			});
		});
	};

})(window.d3_wp_themejs);
